import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CustomDecimalPipe } from './custom-number.pipe';

@NgModule({
  exports: [CustomDecimalPipe],
  imports: [CommonModule, CustomDecimalPipe],
})
export class CustomDecimalModule {}
